import { BLACK_700, BLACK_800, GREEN_600 } from '@airtel/air-design-system';
export var getPackDetailsText = (isSmallScreen, plan, isSubHeading) => {
  var headingType = isSmallScreen ? 'body-single-line-sm-bold' : 'body-single-line-md-bold';
  var subHeadingType = isSmallScreen ? 'body-single-line-xs' : 'body-single-line-sm';
  var _plan$heading = plan.heading,
    heading = _plan$heading === void 0 ? '' : _plan$heading,
    _plan$subHeading = plan.subHeading,
    subHeading = _plan$subHeading === void 0 ? '' : _plan$subHeading;
  var data = [];
  if (!isSubHeading) {
    {
      !!heading && data.push({
        text: heading,
        type: headingType,
        color: BLACK_800
      });
    }
  } else {
    {
      !!subHeading && data.push({
        text: subHeading,
        type: subHeadingType,
        color: BLACK_700
      });
    }
  }
  return data;
};
export var getPriceDetailsText = (isSmallScreen, priceDetails, isSubHeading, subTextColor) => {
  var priceTextType = isSmallScreen ? 'body-single-line-md-bold' : 'body-single-line-lg-bold';
  var gstDetailsTextType = isSmallScreen ? 'body-para-xxs' : 'body-single-line-xs';
  var oldPriceTextType = isSmallScreen ? 'body-single-line-xs' : 'body-single-line-sm';
  var offerTextType = isSmallScreen ? 'body-para-xxs-bold' : 'body-single-line-xs-bold';
  var price = priceDetails.price,
    oldPrice = priceDetails.oldPrice,
    gstDetails = priceDetails.gstDetails,
    offerText = priceDetails.offerText,
    gstDetailsAccessibilityProps = priceDetails.gstDetailsAccessibilityProps;
  var data = [];
  if (!isSubHeading) {
    {
      !!price && data.push({
        text: price,
        type: priceTextType
      });
    }
    {
      !!gstDetails && data.push(Object.assign({
        text: " " + gstDetails,
        type: gstDetailsTextType,
        color: subTextColor
      }, gstDetailsAccessibilityProps));
    }
  } else {
    {
      !!oldPrice && data.push({
        text: oldPrice,
        type: oldPriceTextType,
        isStriked: true,
        color: subTextColor
      });
    }
    {
      !!offerText && data.push({
        text: " " + offerText,
        type: offerTextType,
        color: GREEN_600
      });
    }
  }
  return data;
};